import React from "react";
import "./ActiveUsersData.css"
import ActiveUsersData_card from "./activeUsersData_card/ActiveUsersData_card";

function ActiveUsersData() {
  return (
    <>
      <section className="ActiveUsersData">
        <div className="row">
          <div className="col-lg-12 col-sm-6 col-12">
            <ActiveUsersData_card />
          </div>

          <div className="col-lg-12 col-sm-6 col-12">
            <ActiveUsersData_card />
          </div>

          <div className="col-lg-12  col-sm-6 col-12">
            <ActiveUsersData_card />
          </div>

          <div className=" col-lg-12 col-sm-6 col-12">
            <ActiveUsersData_card />
          </div>
        </div>
      </section>
    </>
  );
}

export default ActiveUsersData;
